import React from "react";
import styles from "./SectionTariff.module.scss";
import Button from "../Button/Button";
import LazyImage from "../LazyImage/LazyImage";
import {useModal} from "../../context/ModalContext";
import tariffData from "../../data/tariffData.json";

const SectionTariff: React.FC = () => {
    const {openModalA} = useModal();
    const {openModalB} = useModal();

    return (
        <div className={styles.sectionTariff}>
            <LazyImage className={styles.sectionTariffImage}
                       src="./assets/images/general/sectionTariff.png"
                       alt="Свой Комфорт Trial"/>
            <div className={styles.sectionTariffRow}>
                <p className={styles.sectionTariffTitle}>
                    {tariffData[0].titleTariff}
                </p>
                <p className={styles.sectionTariffText}>
                    Начните путь к благополучию уже сегодня
                </p>
                <div className={styles.sectionTariffList}>
                    {tariffData[0].data.map((item, idx) =>
                        <div className={styles.sectionTariffListRow} key={idx}>
                            <p className={styles.sectionTariffTitle}>
                                {item.title}
                            </p>
                            <p className={styles.sectionTariffText}>
                                {item.value}
                            </p>
                        </div>
                    )}
                </div>
                <div className={styles.sectionTariffButtons}>
                    <p className={styles.sectionTariffTitle}>
                        {tariffData[0].price}
                    </p>
                    <Button className={styles.sectionTariffButton}
                            classButton="redButton"
                            onClick={openModalB}
                    >
                        Заполнить заявку
                    </Button>
                    <Button className={styles.sectionTariffButton}
                            onClick={openModalA}

                    >
                        Подробнее о тарифе
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default SectionTariff;